﻿window.dataLayer = window.dataLayer || [];

(function ($, document, dataLayer, undefined) {


  // The below checks whether tracking is enabled in the browser
  // If facebook loads, then tracking is fine and we can add GA
  // datalayer checks
  // Otherwise, don't do anything
  var IsTrackingEnabled = false;

  $(function () {
    $('<img/>')
      .attr("src", "//apps.facebook.com/favicon.ico")
      .load(function () { IsTrackingEnabled = true; })
      .css("display", "none")
      .appendTo(document.body);
  });

  var productDatalayerDebug = true;
  var prefix = 'ga4'; // Google Analytics 4
  var openInNewTab = false;

  document.GetNewProductDataLayer = function ($item) {
    if ($item.data(prefix + '-element')) {
      return GetDataLayerData($item);
    } else {
      var $parents = $item.parents('[data-' + prefix + '-element]');
      if ($parents.length) {
        return GetDataLayerData($parents);
      }
    }
    return undefined;
  };

  document.UpdateNewDataLayerOnAddToCart = function (productData) {
    try {
      if (typeof productData !== 'undefined') {
        // GoogleAnalytics/addToCart
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
          event: "add_to_cart_ga4",
          ecommerce: {
            items: [productData]
          }
        });

        if (productDatalayerDebug) {
          console.log('GA4 - Updated datalayer for Add to cart');
          console.log(productData);
        }
      }
    }
    catch (err) {

      if (productDatalayerDebug) {
        console.log('GA4 - Error');
        console.log(err);
      }
    }
  }

  function GetDataLayerData($element) {
    var impression = {};

    try {
      $.each($element.data(), function (i, v) {
        if (i.startsWith(prefix)
          && i !== prefix + '-element'
        ) {
          impression[i.replace(prefix, '').toLowerCase()] = v;
        }
      });
    }
    catch (err) {

      if (productDatalayerDebug) {
        console.log('GA4 - Error');
        console.log(err);
      }
    }

    return impression;
  }

  function RecordImpressions() {
    var productImpressions = [];
    $('[data-' + prefix + '-element]').each(function (n, i) {
      var impression = {};
      var eventName;
      switch ($(this).data(prefix + '-element')) {
        case "manual-button":
        case "product-row":
        case "product-pod":
        case "product-rich-row":
          eventName = 'view_item_list_ga4';
          break;
        case "product-page":
          eventName = 'view_item_ga4';
          break;

      }

      if (eventName.length > 0) {
        var impression = GetDataLayerData($(this));

        if (typeof productImpressions[eventName] === 'undefined') {
          productImpressions[eventName] = {
            eventName: eventName,
            data: []
          };
        }
        productImpressions[eventName].data.push(impression);
      }
    });

    // GoogleAnalytics/ProductPageImpression
    // GoogleAnalytics/ProductPodImpression
    for (const productImpression in productImpressions) {
      dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
      dataLayer.push({
        'event': productImpressions[productImpression].eventName,
        'ecommerce': {
          'items': productImpressions[productImpression].data
        }
      });

      if (productDatalayerDebug) {
        console.log('GA4 - Product Impressions for ' + productImpressions[productImpression].eventName);
        console.log(productImpressions[productImpression].data);
      }
    }
  }

  function RecordClick($link) {
    return new Promise(function (resolve, reject) {

      var $element = $link.parents('[data-' + prefix + '-element]');
      var impression = {};
      var eventName;

      switch ($element.data(prefix + '-element')) {
        case "manual-button":
        case "product-row":
        case "product-pod":
        case "product-rich-row":
          eventName = 'select_item_ga4';
          break;

      }

      if (!eventName || eventName.length < 1) {
        resolve(true);
      }

      var impression = GetDataLayerData($element);
      if (typeof impression === 'undefined') {
        resolve(true);
      }

      // GoogleAnalytics/ProductPodClick
      dataLayer.push({
        'event': eventName,
        'ecommerce': {
          'items': [impression]
        },
        'eventCallback': function () {
          if (productDatalayerDebug) {
            setTimeout(function () {
              resolve(false);
            }, 2000);
          } else {
            resolve(false);
          }
        },
        'eventTimeout': 2000
      });

      if (productDatalayerDebug) {
        console.log('GA4 - Product Click for ' + eventName);
        console.log(impression);
      }

      resolve(false);
    });
  }

  function OpenLink(href) {

    if (openInNewTab) {
      window.open(href, '_blank');
    } else {
      document.location = href;
    }  
  }

  $(document).ready(function () {
    try {
      RecordImpressions();
    }
    catch (err) {
      if (productDatalayerDebug) {
        console.log('GA4 - Error');
        console.log(err);
      }
    }

    $(document).on('change', 'select[data-' + prefix + '-element]', function (e) {
      try {
        // GoogleAnalytics/ClickOnFilterItem
        var dataLayerInfo = [{}];
        var $this = $(this);
        var dataLayerLabel = $this.data(prefix + '-key');
        var dataLayerValue = $this.data(prefix + '-value');
        dataLayerInfo.event = $this.data(prefix + '-event');
        if (typeof dataLayerInfo.event !== 'undefined') {
          dataLayerInfo[dataLayerLabel] = $(dataLayerValue).val();
          dataLayer.push(dataLayerInfo);
          if (productDatalayerDebug) {
            console.log('GA4 - Custom event  for' + dataLayerInfo.event);
            console.log(dataLayerLabel + ': ' + dataLayerValue);
          }
        }
      }
      catch (err) {
        if (productDatalayerDebug) {
          console.log('GA4 - Error');
          console.log(err);
        }
      }
    });

    $(document).on('click', '[data-' + prefix + '-element]', function (e) {
      try {
        // GoogleAnalytics/ClickOnFilterItem
        var $this = $(this);
        var dataLayerInfo = $this.data(prefix + '-data') || {};
        dataLayerInfo.event = $this.data(prefix + '-event');
        if (typeof dataLayerInfo.event !== 'undefined') {
          dataLayer.push(dataLayerInfo);
          if (productDatalayerDebug) {
            console.log('GA4 - Custom event  for' + dataLayerInfo.event);
            console.log(dataLayerInfo);
          }
        }
      }
      catch (err) {
        if (productDatalayerDebug) {
          console.log('GA4 - Error');
          console.log(err);
        }
      }
    });

    $(document).on('click', '[data-' + prefix + '-element] a', function (e) {
      if (!IsTrackingEnabled) {
        return;
      }
      if (!window['google_tag_manager']) {
        return;
      }

      var href = $(this).attr('href');
      if (typeof href === typeof undefined || href === false || href === '' || href === '#') {
        return;
      }

      openInNewTab = (e.ctrlKey || e.metaKey);

      e.preventDefault();
      var shouldRunOpenLinkFallBackPromise = RecordClick($(this));

      shouldRunOpenLinkFallBackPromise.then(function (shouldRunOpenLinkFallBack) {

        if (shouldRunOpenLinkFallBack) {
          setTimeout(function () {
            OpenLink(href);
          }, 5000);
        } else {
          OpenLink(href);
        }
      }).catch(function (err) {
        if (productDatalayerDebug) {
          console.log('GA4 - Error');
          console.log(err);
        }
        OpenLink(this.href);
      });

    });
  });
})(jQuery, document, window.dataLayer);